import React from "react";

type AppProps = {
  handleComment: (e: any) => void;
  commentData: string;
  templateId?:string;
};

const BomComment = ({ handleComment, commentData , templateId}: AppProps) => {
  return (
    <textarea
      className="form-control"
      name="comment"
      style={{ height: "147px", resize: "none", border: "none" }}
      value={commentData}
      disabled={!!templateId}
      onChange={(e: any) => {
        handleComment(e);
      }}
    />
  );
};

export default BomComment;
